<template>
  <section v-if="authenticatedUser" class="mt-3">
    <div>
      <div class="mb-3">
        <GroupsList
          :groups="groups"
          :type2="type1"
          id="my-groups-list"
        ></GroupsList>
      </div>
    </div>
    <div class="overflow-auto" v-if="showPagination">
      <b-pagination
        v-model="pagination.currentPage"
        :total-rows="pagination.totalCount"
        :per-page="pagination.pageSize"
        first-text="First"
        prev-text="Prev"
        next-text="Next"
        last-text="Last"
        align="center"
        @input="getGroups"
      >
      </b-pagination>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import GroupsList from "./GroupsList";
import { eventBus } from "../../main";

export default {
  name: "GroupsSection",
  props: {
    type1: String,
  },
  components: {
    GroupsList,
  },
  data() {
    return {
      UserLogin: this.$store.state.user.login,
      groups: [],
      pagination: {
        currentPage: 1,
        totalCount: 0,
        pageSize: 10,
      },
    };
  },
  created() {

eventBus.$on("NotificationClick", () => {
      this.getGroups()
    });

    // Load groups only if user is logged in
    if (this.authenticatedUser) {
      // Get my groups
      this.getGroups();
    }
  },
  computed: {
    ...mapGetters(["authenticatedUser"]),
    showPagination: function () {
      return this.pagination.totalCount > this.pagination.pageSize;
    },
  },
  methods: {
    initGroups: function () {
      this.groups = [];
    },
    getGroups: function () {
     
      let tempGroups = [];
      let tempOWNGroups = []; 
      

if (this.type1 === "OWN") {

let params = {
        // status: this.type,
        start: this.pagination.pageSize * (this.pagination.currentPage - 1),
        count: this.pagination.pageSize
      }
this.$store.dispatch("getOwnGroups",params).then((data) => {
  this.initGroups();



this.pagination.totalCount=data.totalCount
        tempOWNGroups = data.results;
        console.log(tempOWNGroups);
        //  this.groups.push(data.results)          
         
tempOWNGroups.forEach((group) => {       
          this.groups.push(group);
        });         
      });
}
if (this.type1 === "PUBLIC") {

this.$store.dispatch("getGroupsUser").then((data) => {
  this.initGroups();

        tempGroups = data.groupIds;
        console.log(tempGroups);
        // this.initGroups();
        // Get each group's info
        tempGroups.forEach((groupId) => {
          // let temp = [];
          this.$store.dispatch("getGroupEntity", groupId).then((details) => {
            // temp.id = details.id;
            // temp.name = details.name;
            // temp.created = details.created;
            //  if (
            //   (this.UserLogin === details.creator.login &&
            //     this.type1 === "OWN") ||
            this.UserLogin !== details.creator.login 
            //     this.type1 === "PUBLIC")
            //  ) {
              this.groups.push(details);
            //  }
          });
        });
      });

}
      
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/groups/GroupsSection.vue